/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = MFGTransactionBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MFGTransactionBOMEditor extends _Ext.MFGTransBOMGridEditor<MFGTransactionBOMRow> {



        protected getColumnsKey() { return "Production.MFGTransactionBOM"; }
        protected getDialogType() { return MFGTransactionBOMDialog; }
        protected getLocalTextPrefix() { return MFGTransactionBOMRow.localTextPrefix; }
        protected form: MFGTransactionBOMForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MFGTransactionItemsDialog).CalculateTotals();
                }
            })
        }

        public getId(entity: MFGTransactionBOMRow) {
            return (entity as any)[this.getIdProperty()];
        }
        private Master;
        //public setEditValue(source: DismantlingRow, property) {
        //    super.setOwnerEntity(source);
        //    this.Master = source;
        //    super.setEditValue(source, property);
        //}
        public setdata(items: MFGTransactionBOMRow[]) {
            this.view.setItems([], false);
            for (let Detail of items) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Detail);
            }
        }
        public cleardata() {

            this.view.setItems([],false);

        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }




        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();

            return [Serenity.ColumnPickerDialog.createToolButton(this as any)];
            return buttons;
        }

    }
}